import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6c253cbe"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  class: "status_list"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-downmoreweibo"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-downmoreweibo"
}, null, -1));
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
import SheetBottom from '@@/compose/sheetBottom.vue';
import { zcCategory } from "@api/index";
import { reactive, computed, onMounted } from 'vue';
import env from "md-base-tools/env";
import { showFailToast } from 'vant';
export default {
  emits: ['setCategory', 'setStatus', 'setRank'],
  setup(__props, {
    emit: emits
  }) {
    const isShow = computed(() => env.isWxApp());
    const state = reactive({
      hideDim: false,
      nav: [],
      category: localStorage.getItem("list_category") || 'all',
      status_item: '',
      status: '',
      status_list: [],
      statusVisible: false,
      rank_item: '',
      rank: '',
      rank_list: [],
      rankVisible: false
    });
    onMounted(() => {
      let timer = null;
      timer = setInterval(function () {
        if (document.getElementsByClassName('nav_list_active')[0].offsetLeft) {
          clearInterval(timer);
          document.getElementsByClassName('nav')[0].scrollLeft = document.getElementsByClassName('nav_list_active')[0].offsetLeft;
        }
      }, 300);
    });
    const hideDim = e => {
      if (e.srcElement.scrollLeft + e.srcElement.offsetWidth > e.srcElement.scrollWidth - 30) {
        state.hideDim = true;
      } else {
        state.hideDim = false;
      }
    };
    zcCategory({}).then(res => {
      if (res.status == 0 && res.data.category) {
        state.nav.push(...res.data.category);
        state.nav.forEach(item => {
          if (item.def == 1) {
            state.status_list.push(...item.status_list);
            state.status_item = item.status_list[0].title;
            state.status = item.status_list[0].val;
          }
        });
        state.rank_list.push(...res.data.rank_list);
        state.rank_item = state.rank_list[0].title;
        state.rank = state.rank_list[0].val;
      } else {
        showFailToast(res.message);
      }
    });
    // eslint-disable-next-line no-undef

    const checkCategory = item => {
      localStorage.setItem("list_category", item.category);
      state.category = item.category;
      emits('setCategory', item.category);
      state.status_list = [];
      state.status_list.push(...item.status_list);
      let flag = item.status_list.filter(item => item.title == state.status_item);
      if (flag.length == 0) {
        state.status_item = item.status_list[0].title;
        state.status = item.status_list[0].val;
      }
    };
    const checkStatus = item => {
      state.status = item.val;
      emits('setStatus', item.val);
      state.status_item = item.title;
      state.statusVisible = false;
    };
    const checkRank = item => {
      state.rank = item.val;
      emits('setRank', item.val);
      state.rank_item = item.title;
      state.rankVisible = false;
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(['top_nav', {
          'scrollIng': !_unref(state).hideDim
        }, {
          'top': _unref(isShow)
        }])
      }, [_createElementVNode("div", {
        class: "nav",
        onScroll: hideDim
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).nav, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['item', {
            'nav_list_active': item.category == _unref(state).category
          }]),
          onClick: _withModifiers($event => checkCategory(item), ["stop"])
        }, _toDisplayString(item.name), 11, _hoisted_1);
      }), 128))], 32), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => _unref(state).statusVisible = true, ["stop"]))
      }, [_createTextVNode(_toDisplayString(_unref(state).status_item), 1), _hoisted_3]), _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => _unref(state).rankVisible = true, ["stop"]))
      }, [_createTextVNode(_toDisplayString(_unref(state).rank_item), 1), _hoisted_4])])], 2), _createVNode(SheetBottom, {
        show: _unref(state).statusVisible,
        onClose: _cache[3] || (_cache[3] = $event => _unref(state).statusVisible = false)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).status_list, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: _withModifiers($event => checkStatus(item), ["stop"])
          }, _toDisplayString(item.title), 9, _hoisted_5);
        }), 128)), _createElementVNode("div", {
          class: "cancel",
          onClick: _cache[2] || (_cache[2] = _withModifiers($event => _unref(state).statusVisible = false, ["stop"]))
        }, "取消")]),
        _: 1
      }, 8, ["show"]), _createVNode(SheetBottom, {
        show: _unref(state).rankVisible,
        onClose: _cache[5] || (_cache[5] = $event => _unref(state).rankVisible = false)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).rank_list, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: index,
            onClick: _withModifiers($event => checkRank(item), ["stop"])
          }, _toDisplayString(item.title), 9, _hoisted_6);
        }), 128)), _createElementVNode("div", {
          class: "cancel",
          onClick: _cache[4] || (_cache[4] = _withModifiers($event => _unref(state).rankVisible = false, ["stop"]))
        }, "取消")]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};